// @flow
import type { Action } from 'app/common/redux/types';

export type State = {
  googleOneTapFail: boolean,
};

const googleOneTapReducer = (state: State = { googleOneTapFail: false }, action: Action): State => {
  if (action.type === 'GOOGLE_ONE_TAP_FAILED') {
    return { googleOneTapFail: true };
  }
  return state;
};

export default googleOneTapReducer;
